// extracted by mini-css-extract-plugin
export default {"message":"Message_message__UdveK","__success":"Message___success__F6fKj","__error":"Message___error__zsnJL"};